import React from 'react';

import {
	styled,
	ThemeProvider
} from 'ps-gui';
import 'ps-gui/dist/index.css';
import PortalRoot from './portalroot';
import { getTheme } from './data/themes/themes';

const AppWrapper = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
	overflow: auto;
	background: rgb(251, 251, 251);
	color: ${props => props.theme.textColor};

		::-webkit-scrollbar {
			width: 12px;
			height: 12px;
		}

		scrollbar-color: #a6a6a6 transparent;
		scrollbar-width: thin;

		/* Track */
		::-webkit-scrollbar-track {
			background: transparent;
			border-right: none;
			border-top: none;
			border-bottom: none;
			border-left: none;
			border-top-left-radius: 0px;
			border-bottom-left-radius: 0px;
		}

		::-webkit-scrollbar-thumb {
			background-color: #a6a6a6;
			border: 2px solid transparent;
			border-radius: 0px;
			background-clip: content-box;
		}

		::-webkit-scrollbar-corner {
			background: transparent;
		}

		* {
			scrollbar-color: ${props => props.theme.scrollThumbColor} transparent;
			scrollbar-width: thin;

			::-webkit-scrollbar {
				width: 8px;
				height: 8px;
			}

			/* Track */
			::-webkit-scrollbar-track {
				background: transparent;
				border-right: none;
				border-top: none;
				border-bottom: none;
				border-left: none;
				border-top-left-radius: 0px;
				border-bottom-left-radius: 0px;
			}

			::-webkit-scrollbar-thumb {
				background-color: ${props => props.theme.scrollThumbColor};
				/*border: 2px solid transparent;*/
				border-radius: 4px;
				background-clip: content-box;
			}

			::-webkit-scrollbar-corner {
				background: transparent;
			}
		}

	svg {
		pointer-events: none;
	}

	#psGuiPopupContainer {
		position: fixed; left: 0px; top: 0px; height:100%;
	}

	h1 {
		font-weight: 700;
		font-size: 28px;
		line-height: 40px;
		color: ${props => props.theme.disabledTextColor};
	}

	h2 {
		font-weight: 700;
		font-size: 20px;
		color: ${props => props.theme.disabledTextColor};
		line-height: 36px;
	}

	.ps-button {
		&[type=full], &[type=medium] {
			text-transform: uppercase;
		}
	}

	a {
		&.email {
			font-size: 16px;
			font-weight: 500;
			text-decoration: none;
			&:hover {
				text-decoration: underline;
			}
			color: ${props => props.theme.textColor};
		}
	}
`;

export default class App extends React.PureComponent {
	constructor() {
		super();
		this.state = {
			theme: getTheme('default')
		};
		this.setTheme = this.setTheme.bind(this);
		window.setTheme = this.setTheme;
	}

	setTheme(type, options) {
		this.setState({
			theme: getTheme(type, options)
		});
	}

	render() {
		return (
			<ThemeProvider theme={this.state.theme}>
				<AppWrapper>
					<PortalRoot/>
					<div id="psGuiPopupContainer"/>
				</AppWrapper>
			</ThemeProvider>
		);
	}
}
